import React, {Component} from 'react';
import HomePage from './components/HomePage';
import Interviews from "./components/Interviews";
import ResultsTable from "./components/ResultsTable";
import Teams from "./components/Teams";

import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

class App extends Component {

    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={HomePage}/>
                    <Route path="/teamSessions" component={Teams}/>
                    <Route path="/interviewSessions" component={Interviews}/>
                    <Route path="/resultsTable" component={ResultsTable}/>
                </Switch>
            </Router>
        );

    }
}

export default App;
